import React from "react";
import { ClassNameProps, Column, makeClassName, StyleProps } from "@hex-insights/core";
import { EmployeeDetailQuery } from "../../../../Utilities";
import { Body } from "./Body";
import { Header } from "./Header";
import { DetailViewSubPageInfos, newAcademicsPageInfo, newOverviewPageInfo } from "./pageinfo";
import { DetailRouteContext } from "./RouteContext";
import styles from "./styles.module.css";

export { type HeaderProps as DetailViewHeaderProps } from "./Header";
export { type BodyProps as DetailViewBodyProps } from "./Body";
export { type DetailViewSubPageInfo, type DetailViewSubPageInfos } from "./pageinfo";

export type DetailViewProps = {
	employee: EmployeeDetailQuery["employee"];
	subPageInfos: DetailViewSubPageInfos;
} & Partial<ClassNameProps & StyleProps>;

export function DetailView({ employee, subPageInfos, className, style }: DetailViewProps) {
	const contextValue = React.useMemo(() => ({ subPageInfos }), [subPageInfos]);

	return (
		<DetailRouteContext.Provider value={contextValue}>
			<Column
				justify="spaced-start"
				verticalSpacing="1rem"
				className={makeClassName(styles["main-column"], className)}
				style={style}
			>
				<DetailView.Header employee={employee} />
				<DetailView.Body employee={employee} />
			</Column>
		</DetailRouteContext.Provider>
	);
}

DetailView.Header = Header;
DetailView.Body = Body;

DetailView.newOverviewPageInfo = newOverviewPageInfo;
DetailView.newAcademicsPageInfo = newAcademicsPageInfo;
